import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import About from "./components/About";
import Bracelets from "./components/Bracelets";
import ContactPage from "./components/ContactPage";
import Earrings from "./components/Earrings";
import Footer from "./components/Footer";
import Gifts from "./components/Gifts";
import Index from "./components/Index";
import LabGrown from "./components/LabGrown";
import Navbar from "./components/Navbar";
import Necklaces from "./components/Necklaces";
import PrivacyPolicy from "./components/PrivacyPolicy";
import ProductPage from "./components/ProductPage";
import Ring from "./components/Ring";
import Trending from "./components/Trending";
import Login from "./components/Login";
import Register from "./components/Register";
import Wishlist from "./components/Wishlist";
import CartPage from "./components/CartPage";
import Checkout from "./components/Checkout";
import Terms from "./components/Terms";
import Shipping from "./components/Shipping";


function App() {
  return (
    <>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/ring" element={<Ring />} />
          <Route path="/trending" element={<Trending />} />
          <Route path="/earrings" element={<Earrings />} />
          <Route path="/necklaces" element={<Necklaces />} />
          <Route path="/bracelets" element={<Bracelets />} />
          <Route path="/lab-grown" element={<LabGrown />} />
          <Route path="/gifts" element={<Gifts />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/product" element={<ProductPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/shipping" element={<Shipping />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </>
  );
};

export default App;